import React from "react";

interface FormSubmitButtonProps {
  text?: string;
  attributes?: Record<string, unknown>;
}

/*
 * Override for builder.io/react's built-in "Form:SubmitButton" component.
 *
 * Builder.io v8 fails to pass component options (like `text`) to registered
 * components during SSR, causing the button to render empty on the server but
 * with content on the client. suppressHydrationWarning tells React to accept
 * the server HTML and use the client-rendered content after hydration.
 */
export default function FormSubmitButton({
  text,
  attributes,
}: FormSubmitButtonProps) {
  return (
    <button
      type="submit"
      suppressHydrationWarning
      {...(attributes as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {text}
    </button>
  );
}
